import { Col, Row, Select, SelectProps } from "antd";

interface TablePagiCountFormProps extends SelectProps {}

/**
 * 테이블폼 페이지 수 변경 폼 (분리)
 * @param param0
 * @returns
 */
export const TablePagiCountForm: React.FC<TablePagiCountFormProps> = ({
  onSelect,
  defaultValue = 20,
  ...props
}) => {
  return (
    <Row gutter={[8, 0]} align="middle">
      <Col>
        <Select
          options={[
            { label: "10", value: 10 },
            { label: "20", value: 20 },
            { label: "30", value: 30 },
          ]}
          onSelect={onSelect}
          defaultValue={defaultValue}
          {...props}
        />
      </Col>
      <Col>개씩 보기</Col>
    </Row>
  );
};
